const EmailTemplate = {
  emailTemplate: 'Email Template',
  addEmailTemplate: 'Add Email Template',
  editEmailTemplate: 'Edit Email Template',
};
export default EmailTemplate;
